<template>
  <basic-container>
    <div class="approval-page">
      <el-tabs v-model="activeTab" @tab-click="handleSearch">
        <el-tab-pane label="我的待办" name="todo" />
        <el-tab-pane label="我的已办" name="done" />
      </el-tabs>
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="事件标题"><el-input v-model="query.eventName" clearable placeholder="请输入事件标题" /></el-form-item>
        <el-form-item label="状态"><el-select v-model="query.assignStatus" clearable placeholder="请选择"><el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item>
        <el-form-item label="优先级"><el-select v-model="query.urgencyLevel" clearable placeholder="请选择"><el-option v-for="item in urgencyOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item>
        <el-form-item label="时间"><el-date-picker v-model="query.timeRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" /></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button><el-button icon="el-icon-refresh" @click="handleReset">重置</el-button></el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="tableData" border size="small" empty-text="暂无审批工单">
        <el-table-column label="工单编号" width="150"><template slot-scope="{ row }">{{ row.workOrderNo || row.id }}</template></el-table-column>
        <el-table-column label="事件标题" prop="eventName" min-width="180" show-overflow-tooltip />
        <el-table-column label="优先级" prop="urgencyLevel" width="110"><template slot-scope="{ row }">{{ optionLabel(urgencyOptions, row.urgencyLevel) }}</template></el-table-column>
        <el-table-column label="区域" prop="areaName" width="120" show-overflow-tooltip />
        <el-table-column label="工作组" prop="groupName" min-width="130" show-overflow-tooltip />
        <el-table-column label="状态" prop="assignStatus" width="110"><template slot-scope="{ row }"><el-tag size="small" :type="statusTag(row.assignStatus)">{{ optionLabel(statusOptions, row.assignStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="派工时间" prop="assignTime" width="165" show-overflow-tooltip />
        <el-table-column label="操作" fixed="right" width="170">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
            <el-button v-if="activeTab === 'todo'" type="text" size="small" @click="openAudit(row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="page-bar" background :current-page.sync="page.currentPage" :page-size.sync="page.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="page.total" @current-change="loadList" @size-change="handleSizeChange" />

      <el-dialog title="工单审核" :visible.sync="auditVisible" width="560px" append-to-body>
        <el-form :model="auditForm" label-width="90px">
          <el-form-item label="审核结果"><el-radio-group v-model="auditForm.auditResult"><el-radio label="pass">通过</el-radio><el-radio label="back">驳回</el-radio></el-radio-group></el-form-item>
          <el-form-item label="意见"><el-input v-model="auditForm.opinion" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
        </el-form>
        <span slot="footer"><el-button @click="auditVisible = false">取消</el-button><el-button type="primary" :loading="actionLoading" @click="submitAudit">确定</el-button></span>
      </el-dialog>

      <el-dialog title="工单详情" :visible.sync="detailVisible" width="760px" append-to-body>
        <div v-loading="detailLoading" class="detail-grid">
          <div v-for="item in detailFields" :key="item.label" class="detail-item" :class="{ wide: item.wide }"><span>{{ item.label }}</span><strong>{{ item.value || '-' }}</strong></div>
        </div>
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
import { getTodoList, getDoneList, getDetail, audit } from './api'

const urgencyOptions = [{ label: '特别重大', value: 1 }, { label: '重大', value: 2 }, { label: '较大', value: 3 }, { label: '一般', value: 4 }]
const statusOptions = [{ label: '待接单', value: 1 }, { label: '处理中', value: 2 }, { label: '已完成', value: 3 }, { label: '已超时', value: 4 }]

export default {
  name: 'EmergencyWorkOrderApproval',
  data () {
    return {
      activeTab: 'todo',
      query: {},
      tableData: [],
      loading: false,
      page: { currentPage: 1, pageSize: 10, total: 0 },
      auditVisible: false,
      auditForm: {},
      actionLoading: false,
      detailVisible: false,
      detailLoading: false,
      detail: {},
      urgencyOptions,
      statusOptions
    }
  },
  computed: {
    detailFields () {
      const row = this.detail || {}
      return [
        { label: '工单编号', value: row.workOrderNo || row.id },
        { label: '事件标题', value: row.eventName },
        { label: '优先级', value: this.optionLabel(this.urgencyOptions, row.urgencyLevel) },
        { label: '区域', value: row.areaName || row.areaCode },
        { label: '工作组', value: row.groupName },
        { label: '状态', value: this.optionLabel(this.statusOptions, row.assignStatus) },
        { label: '工作描述', value: row.workDescription, wide: true },
        { label: '处置内容', value: row.disposalContent, wide: true }
      ]
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    buildQuery () {
      const params = { ...this.query, page: this.page.currentPage, size: this.page.pageSize }
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0]
        params.endTime = params.timeRange[1]
      }
      delete params.timeRange
      return params
    },
    async loadList () {
      this.loading = true
      try {
        const request = this.activeTab === 'todo' ? getTodoList : getDoneList
        const res = await request(this.buildQuery())
        const data = res.data && res.data.data
        this.tableData = (data && data.records) || []
        this.page.total = (data && data.total) || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch () {
      this.page.currentPage = 1
      this.loadList()
    },
    handleReset () {
      this.query = {}
      this.handleSearch()
    },
    handleSizeChange () {
      this.page.currentPage = 1
      this.loadList()
    },
    openAudit (row) {
      this.auditForm = { taskId: row.id, auditResult: 'pass', opinion: '' }
      this.auditVisible = true
    },
    async submitAudit () {
      this.actionLoading = true
      try {
        await audit(this.auditForm)
        this.$message.success('审核成功')
        this.auditVisible = false
        this.loadList()
      } finally {
        this.actionLoading = false
      }
    },
    async openDetail (row) {
      this.detailVisible = true
      this.detailLoading = true
      try {
        const res = await getDetail(row.id)
        this.detail = (res.data && res.data.data) || {}
      } finally {
        this.detailLoading = false
      }
    },
    optionLabel (options, value) {
      const item = options.find(option => String(option.value) === String(value))
      return item ? item.label : (value || '-')
    },
    statusTag (value) {
      if (Number(value) === 3) return 'success'
      if (Number(value) === 4) return 'danger'
      if (Number(value) === 2) return 'warning'
      return 'primary'
    }
  }
}
</script>

<style scoped lang="scss">
.page-bar { margin-top: 12px; text-align: right; }
.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}
.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  span { flex: 0 0 100px; padding: 10px; color: #606266; background: #f5f7fa; }
  strong { flex: 1; padding: 10px; font-weight: 400; word-break: break-all; }
}
.detail-item.wide { grid-column: span 2; }
</style>
